<template>
    <div class="body-inner">
        <header-landing-component></header-landing-component>

        <div id="slider" class="inspiro-slider dots-creative" data-height-xs="360">
            <!-- Slide 2 -->
            <div class="slide kenburns" style="background-image:url('../../assets/images/cisco/cisco_bg_banner.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="slide-captions text-center text-light">
                        <!-- Captions -->
                        <span class="strong">Certificaciones</span>
                        <h1>Cisco Certified Support Technician<br></h1>
                        <!-- end: Captions -->
                    </div>
                </div>
            </div>
            <!-- end: Slide 2 -->
        </div>
        <!--end: Inspiro Slider -->
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="heading-text heading-section">
                            <h2 style="font-size: 2.85rem">PROGRAMA DE CERTIFICACIÓN CISCO (CCST)</h2>
                        </div>
                        <img src="../../assets/images/cisco/cisco.png">
                    </div>
                    <div class="col-lg-8">
                        <div class="row">
                            <div class="col-lg-10">
                                Cisco, líder mundial en tecnología que impulsa Internet, se ha asociado con Certiport para crear el programa de certificación <strong>Cisco Certified Support Technician (CCST)</strong>. Este programa incluye dos exámenes diseñados para validar habilidades listas para el trabajo que ayudan a los estudiantes a ingresar al campo de las redes y la ciberseguridad.
                                <hr>
                                <br>
                                <h4>EXÁMENES DE CERTIFICACIÓN DISPONIBLES:</h4>
                                <ul class="list-icon list-icon-check">
                                    <li>Cisco Certified Support Technician Networking</li>
                                    <li>Cisco Certified Support Technician Cybersecurity</li>
                                </ul>
                                <br>
                                <p class="text-bold">Obtener estas certificaciones demuestra las habilidades del estudiante al mundo empresarial, indicándoles que están listos para ponerse manos a la obra en su primer día.</p>
                                <p>Los exámenes de certificación Cisco Certified Support Technician, fueron creados por un equipo de expertos en la materia, provenientes de diversas carreras e industrias (incluyendo empleados de Cisco, profesionales de redes y la ciberseguridad, gerentes de contratación, profesores, maestros y los expertos de Certiport), con el objetivo de asegurar que estas certificaciones llenen la brecha entre la educación y las habilidades necesarias para tener éxito en el mundo empresarial, preparando a los estudiantes para puestos de alta demanda en ciberseguridad y redes, tales como analistas, auditores, especialistas de soporte y técnicos.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="bg-light">
            <div class="container">
                <h3 class="text-center text-bold">OBJETIVOS DE APRENDIZAJE</h3>
                <br>
                <div class="row mb-4">
                    <div class="col-md-6">
                        <h4>OBJETIVOS DE CCST NETWORKING</h4>
                        <ul class="list-icon list-icon-check">
                            <li>Estándares y conceptos de redes</li>
                            <li>Formatos de dirección y subredes</li>
                            <li>Endpoints y Media Types</li>
                            <li> Infraestructuras de red</li>
                            <li> Diagnóstico de problemas</li>
                            <li>Seguridad de red</li>
                        </ul>
                    </div>
                    <div class="col-md-6">
                        <h4>OBJETIVOS DE CCST CYBERSECURITY</h4>
                        <ul class="list-icon list-icon-check">
                            <li>Principios esenciales de seguridad</li>
                            <li> Conceptos básicos de seguridad de redes</li>
                            <li> Conceptos de seguridad de Endpoints</li>
                            <li>  Evaluación de vulnerabilidades y gestión de riesgos</li>
                            <li> Manejo de incidentes</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <section class="section-fullwidth text-light p-b-0">
            <div class="row">
            </div>
        </section>
        <!--call-to-action dark -->
        <div class="call-to-action p-t-100 p-b-100  mb-0 call-to-action-dark">
            <div class="container">
                <div class="row">
                    <div class="col-lg-10">
                        <h3>
                            ¿Quieres agregar esta credencial con validez internacional a tu CV?
                        </h3>
                        <p>
                            Conoce todas las soluciones que Global Certification Academy ofrece para agregar VALOR A TU CURRÍCULUM.
                        </p>
                    </div>
                    <div class="col-lg-2"><router-link class="btn btn-primary btn-lg" to="/register">INSCRIBIRME</router-link></div>
                </div>
            </div>
        </div>
        <!--end: call-to-action dark -->
        <LeadComponent></LeadComponent>
        <footer-landing-component></footer-landing-component>
    </div>
</template>

<script>
import HeaderLandingComponent from "../../components/Landing/HeaderLandingComponent.vue"
import FooterLandingComponent from "../../components/Landing/FooterLandingComponent.vue"
import LeadComponent from "../../components/Landing/LeadComponent.vue"
export default {
    name: 'cisco',
    components: {
        HeaderLandingComponent,
        FooterLandingComponent,
        LeadComponent
    },   
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
    }        
}

</script>                